export default import.meta.ROLLDOWN_FILE_URL_Q2f6DVlFyPsOk$b2Q3trRA